// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "bundle.6e8d8474b1ca82dbfa6167c79f7e72fc.css";
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"23":"87e538ec4c72699060136865e49f1800","795":"ff76e681a62ff84d9b79869b0f4c6ac2"}[chunkId] + ".css";
};